
import {Component, Prop, Vue} from 'vue-property-decorator';

@Component
export default class MapMarker extends Vue {
	@Prop({default: {}, required: true}) private google;
	@Prop({default: {}, required: true}) private map;
	@Prop({default: {}, required: true}) private marker;

	mounted() {
		const { Marker } = this.google.maps;

		const mark = new Marker({
			position: this.marker.position,
			marker: this.marker,
			map: this.map,
			title: this.marker.title,
			icon: 'marker.png' 
		});
		const component = this;
		this.google.maps.event.addListener(mark, 'click', function (event) {
			component.$emit('selected', component.marker.id)
		});
	}

	render() {
		const a = null;
	}
}
